import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import '../../containers/invoices/invoices.css';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';

/* tslint:disable */
type DragonsProps = HeaderState & // ... state we've requested from the Redux store
    typeof headerActionCreators & // ... plus action creators we've requested
    RouteComponentProps<{}>;

class Dragons extends React.Component<DragonsProps, {}> {
    constructor(props: DragonsProps) {
        super(props);

        this.state = {
            popoverOpen: false
        };
    }

    componentWillMount() {
        this.props.setBottomHeader('My Quick Dragons Online');
    }

    public render() {
        return (
            <div className="container">
                <div className="componentHeader">
                    <div className="item tile">
                        <div className="tileHead">
                            <div className="float-left">
                                <h4>{'Here be dragons'}</h4>
                            </div>
                            <div className="tileImage float-right">
                                {
                                    <img src="https://img.etsystatic.com/il/38b8f3/1197985714/il_570xN.1197985714_7ra0.jpg?version=1" />
                                }
                            </div>
                        </div>
                        <div className="tileBody">
                            <div className="topBorder" />
                            <h3>Under construction</h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(
        (state: ApplicationState) => state.header, // Selects which state properties are merged into the component's props
        headerActionCreators // Selects which action creators are merged into the component's props
    )(Dragons)
);



// WEBPACK FOOTER //
// ./src/containers/test/hereBeDragons.tsx